import { Box } from '@mui/material';
import GrayLine from './GrayLine';

type PageLinesType = {
  style?: React.CSSProperties;
  width?: any;
  top?: number;
  left?: number;
  children?: any;
  isOneLine?: boolean;
  isNarrow?: boolean;
  isWide?: boolean;
  isExtraWide?: boolean;
  marginLeft?: number;
  paddingTop?: number;
  margin?: string;
  isLastLine?: boolean;
  isFirstLine?: boolean;
  addThickLine?: boolean;
  isNotLastSection?: boolean;
  sectionNumber?: number;
} & Partial<React.HTMLAttributes<HTMLDivElement>>;

const PageLines = ({
  style,
  top,
  left,
  isOneLine,
  width,
  isNarrow,
  isWide,
  isExtraWide,
  marginLeft,
  paddingTop,
  margin,
  isFirstLine,
  isLastLine,
  addThickLine,
  isNotLastSection,
  sectionNumber,
  ...props
}: PageLinesType): React.ReactElement => {
  return (
    <Box
      className="pageLines"
      sx={{
        left: left ?? '34px',
        top: top ?? '162px',
        margin: margin ?? '25px 0',
        width: 'max-content',
        ...style
      }}
      {...props}
    >
      {isFirstLine && <div id={`blueBackground-${sectionNumber}`} />}
      {!isOneLine && (
        <GrayLine
          isTop
          width={width || 725}
          marginLeft={marginLeft}
          isWide={isWide}
          paddingTop={paddingTop}
          isExtraWide={isExtraWide}
          isNarrow={isNarrow}
        />
      )}

      {props?.children}
      <GrayLine
        width={width || 725}
        isNarrow={isNarrow}
        marginLeft={marginLeft}
        isWide={isWide}
        paddingTop={paddingTop}
        isExtraWide={isExtraWide}
      />
      {addThickLine && isLastLine && isNotLastSection && (
        <GrayLine
          width={width || 725}
          isNarrow={isNarrow}
          isThickLine
          paddingTop={isNarrow ? 50 : 40}
          style={{
            width: '775px',
            zIndex: 2
          }}
        />
      )}
    </Box>
  );
};

export default PageLines;
